import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class MasterTemplateGuard implements CanActivate {
  constructor(
    private readonly _auth: AuthService,
    private readonly _router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    if (this._auth.user?.operatorAcssLvls !== 'none') {
      return of(true);
    }

    return this._auth.resolveAccessControlConfig().pipe(
      map((resolved) => {
        const enableTemplate = this._auth.buyerConfig?.enableTemplate ?? false;
        const canAccess = resolved.capabilities.canAccessMasterTemplate;

        if (enableTemplate && canAccess) {
          return true;
        }
        return this._router.parseUrl('/access-denied');
      })
    );
  }
}
